module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-wrapper",
    class: {
      'slideup': !_vm.isMobileMenuOpen, 'slidedown': _vm.isMobileMenuOpen
    }
  }, [_c('nav', {
    staticClass: "ie o-menu o-menu__icon-mob--active",
    class: {
      'o-menu--collapse': _vm.isMenuCollapsed
    },
    on: {
      "mouseleave": _vm.unforce
    }
  }, [_c('icons'), _vm._v(" "), _c('div', {
    staticClass: "o-menu__icon",
    class: {
      'o-menu__icon--animate o-menu--show-sub-menu': _vm.isMenuOpen && !this.forceMenu && this.getSubMenu.allSteps.length
    },
    on: {
      "click": function($event) {
        return _vm.updateMenu(false)
      }
    }
  }, [_c('span', {
    on: {
      "click": _vm.force
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "o-menu__collapse-menu",
    class: {
      'o-menu__collapse-menu--show': _vm.isMenuOpen && !this.forceMenu && this.getSubMenu.allSteps.length
    },
    on: {
      "click": _vm.collapseMenu
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "o-menu__icon-mob--close",
    on: {
      "click": _vm.updateMobileMenu
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "o-menu__m-top-level-nav",
    class: {
      'o-menu__m-top-level-nav--active': _vm.isMenuOpen && !this.forceMenu && this.getSubMenu.allSteps.length
    }
  }, [(_vm.getUserId !== null) ? _c('ul', {
    staticClass: "top-nav-links"
  }, [_c('li', {
    on: {
      "click": _vm.updateMobileMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'homepage'
      },
      "exact": "",
      "active-class": "o-menu__m-top-level-nav--item-active"
    }
  }, [_c('p', [_vm._v("\n                            Homepage\n                        ")])])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.updateMobileMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'executive-dashboard'
      },
      "active-class": "o-menu__m-top-level-nav--item-active"
    }
  }, [_c('p', [_vm._v("\n                            Executive Dashboard\n                        ")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "has-sub",
    class: {
      'remove-border': _vm.currentSubMenu == 'reserving-sub'
    },
    attrs: {
      "id": "reserving"
    }
  }, [_c('a', [_vm._v("\n                        Reserving\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "o-menu__m-top-level-nav--sub-menu-icon",
    class: {
      'rotate': _vm.currentSubMenu == 'reserving-sub'
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#arrow-head"
    }
  })])]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentSubMenu === 'reserving-sub'),
      expression: "currentSubMenu === 'reserving-sub'"
    }],
    staticClass: "sub",
    attrs: {
      "id": "reserving-sub"
    }
  }, [_c('li', {
    on: {
      "click": _vm.updateMobileMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'compare'
      },
      "active-class": "o-menu__m-top-level-nav--item-active"
    }
  }, [_c('p', [_vm._v("\n                                    Reserve vs Paid Comparison\n                                ")])])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.updateMobileMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'reserving::day-one-assessment'
      },
      "active-class": "o-menu__m-top-level-nav--item-active"
    }
  }, [_c('p', [_vm._v("\n                                    Day One Assessment\n                                ")])])], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "has-sub",
    class: {
      'remove-border': _vm.currentSubMenu == 'discount-rate-sub'
    },
    attrs: {
      "id": "discount-rate"
    }
  }, [_c('a', [_vm._v("\n                        Discount Rate\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "o-menu__m-top-level-nav--sub-menu-icon",
    class: {
      'rotate': _vm.currentSubMenu == 'discount-rate-sub'
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#arrow-head"
    }
  })])]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentSubMenu === 'discount-rate-sub'),
      expression: "currentSubMenu === 'discount-rate-sub'"
    }],
    staticClass: "sub",
    attrs: {
      "id": "discount-rate-sub'"
    }
  }, [_c('li', {
    on: {
      "click": _vm.updateMobileMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'discount-rate-comparison'
      },
      "active-class": "o-menu__m-top-level-nav--item-active"
    }
  }, [_c('p', [_vm._v("\n                                    Discount Rate Comparison\n                                ")])])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.updateMobileMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'update-discount-rate'
      },
      "active-class": "o-menu__m-top-level-nav--item-active"
    }
  }, [_c('p', [_vm._v("\n                                    Update Discount Rates\n                                ")])])], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "has-sub",
    class: {
      'remove-border': _vm.currentSubMenu == 'claims-sub'
    },
    attrs: {
      "id": "claims"
    }
  }, [_c('a', [_vm._v("\n                        Claims\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "o-menu__m-top-level-nav--sub-menu-icon",
    class: {
      'rotate': _vm.currentSubMenu == 'claims-sub'
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 120 120"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#arrow-head"
    }
  })])]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentSubMenu === 'claims-sub'),
      expression: "currentSubMenu === 'claims-sub'"
    }],
    staticClass: "sub",
    attrs: {
      "id": "claims-sub"
    }
  }, [_c('li', {
    on: {
      "click": _vm.updateMobileMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'claims'
      },
      "active-class": "o-menu__m-top-level-nav--item-active"
    }
  }, [_c('p', [_vm._v("\n                                    Claims Dashboard\n                                ")])])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.updateMobileMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'fatal::dependency.step-1'
      },
      "active-class": "o-menu__m-top-level-nav--item-active"
    }
  }, [_c('p', {
    on: {
      "click": function($event) {
        return _vm.fetchSubMenu('fatal/dependency')
      }
    }
  }, [_vm._v("\n                                    Fatal Accident Dependency Claim\n                                ")])])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.updateMobileMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'fatal::estate.step-1'
      },
      "active-class": "o-menu__m-top-level-nav--item-active"
    }
  }, [_c('p', {
    on: {
      "click": function($event) {
        return _vm.fetchSubMenu('fatal/estate')
      }
    }
  }, [_vm._v("\n                                    Fatal Accident Estate Claim\n                                ")])])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.updateMobileMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'lost::step-1'
      },
      "active-class": "o-menu__m-top-level-nav--item-active"
    }
  }, [_c('p', {
    on: {
      "click": function($event) {
        return _vm.fetchSubMenu('lost')
      }
    }
  }, [_vm._v("\n                                    Lost Years Claim\n                                ")])])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.updateMobileMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'personal::step-1'
      },
      "active-class": "o-menu__m-top-level-nav--item-active"
    }
  }, [_c('p', {
    on: {
      "click": function($event) {
        return _vm.fetchSubMenu('personal')
      }
    }
  }, [_vm._v("\n                                    Personal Injury Claim\n                                ")])])], 1)])]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.updateMobileMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'mini-calculators'
      },
      "active-class": "o-menu__m-top-level-nav--item-active"
    }
  }, [_c('p', {
    on: {
      "click": function($event) {
        return _vm.fetchSubMenu('mini')
      }
    }
  }, [_vm._v("\n                            Mini Calculators\n                        ")])])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.updateMobileMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'randt::documents'
      },
      "active-class": "o-menu__m-top-level-nav--item-active"
    }
  }, [_c('p', [_vm._v("Resources and Tools")])])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.updateMobileMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'support'
      },
      "active-class": "o-menu__m-top-level-nav--item-active"
    }
  }, [_c('p', [_vm._v("Support")])])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.updateMobileMenu
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.logoutUser()
      }
    }
  }, [_c('p', [_vm._v("Logout\n                            "), _c('span', {
    class: [_vm.loggingOut() ? 'a-loader--white' : ''],
    staticStyle: {
      "margin-top": "-3px",
      "margin-left": "20px"
    },
    attrs: {
      "disabled": _vm.running
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.getUserId === null) ? _c('ul', {
    staticClass: "top-nav-links"
  }, [_c('li', {
    on: {
      "click": _vm.updateMobileMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'homepage'
      },
      "exact": "",
      "active-class": "o-menu__m-top-level-nav--item-active"
    }
  }, [_c('p', [_vm._v("Homepage")])])], 1), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.updateMobileMenu();
        _vm.updatePassportMenu();
      }
    }
  }, [_c('a', {
    staticClass: "loginButton",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.openPassport()
      }
    }
  }, [_c('p', [_vm._v("Login")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "o-menu__m-sub-nav"
  }, [_c('ul', _vm._l((this.getSubMenu.allSteps), function(item, index) {
    return (item.route.path) ? _c('li', [(item.route.path !== 'documents') ? _c('router-link', {
      class: {
        'o-menu__m-sub-nav--visited': item.valid === true
      },
      attrs: {
        "to": item.route,
        "active-class": "o-menu__m-sub-nav--active"
      }
    }, [_c('p', [_vm._v(_vm._s(item.name) + " ")])]) : _vm._e()], 1) : _vm._e()
  }), 0)]), _vm._v(" "), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-menu__back-button"
  }, [_c('p', [_vm._v("Main Menu")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-40aa51d6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation.vue
// module id = 1657
// module chunks = 0